import { Input, OnInit, Component } from '@angular/core';
import { map, timer, takeUntil, Observable } from 'rxjs';

@Component({
  selector: 'tablesready-countdoun-timer',
  templateUrl: './frontend-countdown-timer.component.html',
  standalone: false,
})
export class FrontendCountdownTimerComponent implements OnInit {
  @Input() milliseconds = 0;

  timeRemaining$?: Observable<number>;

  ngOnInit(): void {
    let distance = this.milliseconds - Date.now();
    this. timeRemaining$ = timer(0, 1000)
      .pipe(
        takeUntil(timer(distance)),
        map(() => {
          distance -= 1000;
          return distance > 0 ? distance : 0;
        })
      );
  }
}
